import React, { useEffect, useState } from "react";
import NotificationsTable from "./NotificationsTable";
import { useSearchParams } from "react-router-dom";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import { TableSearch } from "../../../components/common/Tables/DataTableParts";
import { PlusIcon } from "../../../components/common/Icons/Icons";

interface ContainerProps {
  setCreateOpen: any;
  setEditOpen: any;
  setDeleteOpen: any;
  setViewOpen: any;
  setNotifToModify: any;
}

const NotificationsContainer: React.FC<ContainerProps> = ({
  setCreateOpen, setEditOpen, setDeleteOpen, setViewOpen, setNotifToModify,
}) => {
  const { canAccess: canSend } = usePermissionCheck(['can_send_notifications', 'can_send_notifications_to_all']);
  const [title, setTitle] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => { setTitle(searchParams.get('title') ?? ''); }, [searchParams]);

  const handleFilter = () => {
    searchParams.delete('page');
    title === "" ? searchParams.delete('title') : searchParams.set('title', title);
    setSearchParams(searchParams);
  };

  const handleClear = () => {
    searchParams.delete('page');
    setTitle("");
    searchParams.delete('title');
    setSearchParams(searchParams);
  };

  // Title is the only filter, so it's a search box in the toolbar rather than a sidebar
  const toolbar = (
    <>
      {canSend &&
        <button type="button" className="btn btn-sm btn-primary lp-primary-action" onClick={() => setCreateOpen(true)}>
          <PlusIcon/> Create Notification
        </button>}
      <TableSearch
        id="title-search"
        label="Search titles"
        value={title}
        onChange={setTitle}
        onSearch={handleFilter}
        onClear={handleClear}
      />
    </>
  );

  return (
    <NotificationsTable
      setNotifToModify={setNotifToModify}
      setEditOpen={setEditOpen}
      setDeleteOpen={setDeleteOpen}
      setViewOpen={setViewOpen}
      toolbar={toolbar}
    />
  );
};

export default NotificationsContainer;
